import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

interface Screenshot {
  image: string;
  alt: string;
  title: string;
  description: string;
}

const AppPreview = () => {
  const screenshots: Screenshot[] = [
  {
    image: "/assets/images/IMG_3255-1768304669873.PNG",
    alt: "Signaly mobile app home screen displaying live trading signals with real-time price updates and signal confidence indicators",
    title: "Mobile App Home Screen",
    description: "Access live signals and market insights on the go"
  },
  {
    image: "/assets/images/IMG_3256-1768304707496.PNG",
    alt: "Signaly mobile app live trading signals feed showing real-time market movements and AI-generated trading opportunities with confidence scores",
    title: "Live Trading Signals Feed",
    description: "Stream of real-time signals with instant notifications"
  },
  {
    image: "/assets/images/IMG_3260-1768304900627.PNG",
    alt: "Signaly mobile app chat rooms and community interface displaying trader discussions and real-time messaging with user profiles",
    title: "Chat Rooms & Community",
    description: "Join active trading rooms and connect with fellow traders"
  },
  {
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1e2f784e5-1766498706828.png",
    alt: "Signaly app dashboard screen showing live trading signals with green and red indicators on dark interface",
    title: "Live Signals Dashboard",
    description: "Real-time AI-driven signals with 87% confidence rate"
  },
  {
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1608da274-1764671261525.png",
    alt: "Performance analytics screen displaying colorful bar charts and line graphs showing trading statistics",
    title: "Performance Analytics",
    description: "Track your wins, losses, and overall profitability"
  },
  {
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_18893ff1e-1767892348090.png",
    alt: "Paper trading interface with virtual portfolio balance and simulated trade execution buttons",
    title: "Paper Trading",
    description: "Practice with virtual money before going live"
  },
  {
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_10b7d80b6-1764776560079.png",
    alt: "Community chat screen showing trader conversations and signal discussions with user avatars",
    title: "Community Chat",
    description: "Connect with 50,000+ traders worldwide"
  }];


  return (
    <section className="py-20 px-4 lg:px-8 bg-background">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-5xl font-heading font-bold text-foreground mb-4">
            Experience Signaly in Action
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            See how our mobile app delivers professional trading signals in a beautiful, intuitive interface
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {screenshots.map((screenshot, index) =>
          <div key={index} className="group">
              <div className="relative overflow-hidden rounded-2xl bg-card border border-border hover:shadow-cyan-glow transition-all duration-200">
                <div className="aspect-[9/16] relative">
                  <AppImage
                  src={screenshot.image}
                  alt={screenshot.alt}
                  className="w-full h-full object-cover" />

                  <div className="absolute inset-0 bg-gradient-to-t from-background/90 via-background/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-200"></div>
                </div>
                <div className="p-4">
                  <h3 className="text-lg font-heading font-bold text-foreground mb-2">{screenshot.title}</h3>
                  <p className="text-sm text-muted-foreground">{screenshot.description}</p>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="mt-16 bg-gradient-to-br from-primary/10 via-secondary/10 to-accent/10 border border-primary/20 rounded-2xl p-8 lg:p-12">
          <div className="grid lg:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-3xl font-heading font-bold text-foreground mb-4">
                Optimized for Your Trading Success
              </h3>
              <p className="text-lg text-muted-foreground mb-6">
                Our mobile app is designed from the ground up to give you the fastest, most reliable access to AI-driven trading signals.
              </p>
              <ul className="space-y-4">
                {[
                "Lightning-fast signal delivery with push notifications",
                "Offline access to your trading history and saved signals",
                "Biometric security for peace of mind",
                "Widget support for quick signal checks"].
                map((feature, index) =>
                <li key={index} className="flex items-start space-x-3">
                    <Icon name="CheckCircleIcon" size={24} className="text-primary flex-shrink-0 mt-0.5" />
                    <span className="text-foreground">{feature}</span>
                  </li>
                )}
              </ul>
            </div>
            <div className="relative">
              <div className="absolute inset-0 bg-primary/20 rounded-3xl blur-3xl"></div>
              <AppImage
                src="https://img.rocket.new/generatedImages/rocket_gen_img_16cf8fdf2-1767892348088.png"
                alt="Professional trader using Signaly mobile app on smartphone with trading charts visible on screen"
                className="relative z-10 w-full h-auto rounded-2xl shadow-2xl" />

            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default AppPreview;